import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonService } from '../../services/common/common.service';
import { Md5 } from "ts-md5";

@Component({
    standalone: false,
    selector: 'res-custom-input-file',
    templateUrl: './custom-input-file.component.html',
    styleUrls: ['./custom-input-file.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CustomInputFileComponent),
            multi: true
        }
    ]
})
export class CustomInputFileComponent implements ControlValueAccessor {
    @Input() createFileMD5 = false;
    model = { fileName: '', encodedData: null, fileMD5: '' };

    @Input() automationId = 'custom';
    @Input() labelText: string;
    @Input() typesAccepted: string;
    @Input() sizeLimitInMB: number;
    @Input() deleteMessage: string;
    @Input() disabled: boolean;

    constructor(private commonService: CommonService) { }

    private propagateChange = (_: any) => {
        return;
    };

    writeValue(value: any): void {
        if (value) {
            this.model = value;
        }
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        return;
    }

    onAccept($event): void {
        if ($event?.target?.files?.length > 0) {
            const firstFile = $event.target.files[0];
            const fileSize = firstFile.size / 1024 / 1024; // in MiB
            if (this.sizeLimitInMB && fileSize < this.sizeLimitInMB) {
                this.model.fileName = firstFile.name;
                this.handleInputFile(firstFile);
            }
            else {
                this.commonService.openErrorModal('File size exceeds limit');
            }
        }
    }

    onRemove(): void {
        if (this.deleteMessage) {
            this.commonService.openConfirmationDeleteModal(
                this.deleteMessage, 'Warning', 'Delete', 'Cancel'
            ).then((result) => {
                if (result?.modalResult) {
                    this.clearModel();
                }
            });
        } else {
            this.clearModel();
        }
    }

    clearModel() {
        this.model.encodedData = null;
        this.model.fileName = '';
        if (this.createFileMD5) {
            this.model.fileMD5 = '';
        }
        this.propagateChange(this.model);
    }

    handleInputFile(data): void {
        if (data) {
            const reader: any = new FileReader();
            reader.onload = (readerEvt): any => {
                let binaryString = '';

                if (this.commonService.currentBrowserIsIE) {
                    binaryString = this.commonService.convertArrayToBinaryString(reader.result);
                    reader.content = binaryString;
                } else {
                    binaryString = readerEvt.target.result;
                }
                this.model.encodedData = btoa(binaryString);
                if (this.createFileMD5) {
                    this.model.fileMD5 = Md5.hashAsciiStr(binaryString);
                }
                this.propagateChange(this.model);
            };
            if (this.commonService.currentBrowserIsIE) {
                reader.readAsArrayBuffer(data);
            } else {
                reader.readAsBinaryString(data);
            }

            reader.onerror = function (event) {
                console.error('File could not be read! Code ' + event.target.error.code);
            };
        }
    }
}